import Environment from '../utils/Environment';

export interface Column {
  key: string;
  name: string;
}

// Define columns for each tab type
export const tabColumns: Record<string, Column[]> = {
  IN02: [
    { key: 'Facility', name: 'Facility' },
    { key: 'Shipment ID', name: 'Shipment ID' },
    { key: 'Primary Staging Location', name: 'Primary Staging Location' },
    { key: 'Planned Door', name: 'Planned Door' },
    { key: 'Stop #', name: 'Stop #' },
    { key: 'Stop Destination Facility', name: 'Stop Destination Facility' },
    { key: 'Load Group FRZ', name: 'Load Group FRZ' },
    { key: 'Load Group GRO', name: 'Load Group GRO' },
    { key: 'Load Group PER', name: 'Load Group PER' },
    { key: 'Load Group GML', name: 'Load Group GML' },
    { key: 'Load Group PRO', name: 'Load Group PRO' },
    { key: 'Shipment Dispatch Date', name: 'Shipment Dispatch Date' },
  ],
  XDOCK: [
    { key: 'SourceLocationCode', name: 'Source Location Code' },
    { key: 'DestinationLocationCode', name: 'Destination Location Code' },
    { key: 'Cubes', name: 'Cubes' },
    { key: 'ReferenceID', name: 'Reference ID' },
    { key: 'CommodityCode', name: 'Commodity Code' },
    { key: 'Weight', name: 'Weight' },
    { key: 'Cases', name: 'Cases' },
    { key: 'Comments', name: 'Comments' },
  ],
};

// Function to get mandatory field keys based on tab and DC
export const getMandatoryFieldKeys = (tabType: string, selectedDC: string): string[] => {
  if (tabType === 'IN02') {
    // Combined IN02 DCs (e.g. WAUB): only Facility and Shipment ID are mandatory
    const combinedIN02DCs = Environment.getCombinedIN02DCList();
    if (combinedIN02DCs.includes(selectedDC)) {
      return ['Facility', 'Shipment ID'];
    }

    const customIN02DCs = Environment.getCustomIN02DCList();
    const isCustomIN02DC = customIN02DCs.includes(selectedDC);
    const fields = ['Facility', 'Shipment ID', 'Primary Staging Location', 'Planned Door'];
    if (isCustomIN02DC) {
      fields.push('Stop #');
    }
    return fields;
  }
  if (tabType === 'XDOCK') {
    return ['SourceLocationCode', 'DestinationLocationCode', 'Cubes', 'ReferenceID', 'CommodityCode', 'Weight', 'Cases', 'Comments'];
  }
  return [];
};